/* KENT colour galleries: swap the product photos when the colour changes, without reloading the page.
   Data comes from snippets/kent-gallery.liquid (part: 'json'). theme.dev.js calls KentGallery.show()
   on a colour change and only reloads the page when this returns false. */
(function () {
  if (window.KentGallery) return;

  var cache = new WeakMap();

  function parse(raw) {
    var out = {};
    if (!raw) return out;
    raw.split('##').forEach(function (seg) {
      var i = seg.indexOf('^^');
      if (i < 0) return;
      out[seg.slice(0, i)] = seg.slice(i + 2).split('||').map(function (it) {
        var f = it.split('~~');
        return { src: f[0], alt: f[1] || '', w: +f[2] || 1, h: +f[3] || 1, model: f[4] || '' };
      });
    });
    return out;
  }

  function sizer(src, assetBase) {
    if (src.indexOf('A:') === 0) {
      var name = src.slice(2);
      return function (w) { return assetBase + name.replace(/\.(jpe?g|png|webp)$/i, '_' + w + 'x.$1'); };
    }
    var sep = src.indexOf('?') > -1 ? '&' : '?';
    return function (w) { return src + sep + 'width=' + w; };
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function read(container) {
    var el = container.querySelector('script[data-kent-gallery]');
    if (!el) return null;
    if (!cache.has(el)) {
      var raw = '';
      try { raw = JSON.parse(el.textContent); } catch (e) {}
      cache.set(el, {
        map: parse(raw),
        section: el.getAttribute('data-section'),
        lightbox: el.getAttribute('data-lightbox') === 'true',
        assetBase: el.getAttribute('data-asset-base') || '',
        models: (el.getAttribute('data-models') || '').split('||').reduce(function (o, m) {
          var f = m.split('~~');
          if (f[0]) o[f[0]] = 'Model is ' + f[1] + ' and wears size ' + f[2];
          return o;
        }, {})
      });
    }
    return cache.get(el);
  }

  function toEl(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  function build(d, list) {
    var slides = [], thumbs = [];
    list.forEach(function (p, i) {
      var u = sizer(p.src, d.assetBase);
      var id = d.section + '-kg' + (i + 1) + '-' + Date.now();
      var pad = Math.round((p.h / p.w) * 10000) / 100;
      var zh = Math.round((p.h * 2000) / p.w);
      slides.push(toEl(
        '<div class="product-media--image product-image kent-gal-slide' + (i ? ' media--hidden' : '') + '" data-id="' + id + '" data-type="image" data-product-single-media-wrapper data-media-id="' + id + '" data-kg-model="' + esc(d.models[p.model] || '') + '">' +
          '<div class="product-single__media product-single__media--image kent-gal-media">' +
            '<div class="product-single__media--image-height" style="padding-top: ' + pad + '%;"></div>' +
            '<img class="kent-gal-img" src="' + u(900) + '" srcset="' + u(600) + ' 600w, ' + u(900) + ' 900w, ' + u(1200) + ' 1200w, ' + u(1600) + ' 1600w" sizes="(min-width: 990px) 50vw, 100vw" width="600" height="' + Math.round((p.h * 600) / p.w) + '" alt="' + esc(p.alt) + '"' + (i ? ' loading="lazy"' : '') + '>' +
          '</div>' +
          (d.lightbox ? '<a href="' + u(2000) + '" class="product-image__lightbox-link" rel="lightbox" data-zoom-wrapper data-image-width="2000" data-image-height="' + zh + '"><span class="visually-hidden">Open image</span></a>' : '') +
        '</div>'
      ));
      thumbs.push(toEl(
        '<div class="product-single__media-thumb' + (i ? '' : ' active') + '" data-id="' + id + '" data-thumbnail>' +
          '<a href="' + u(2000) + '" class="product-single__thumbnail product-single__thumbnail--' + d.section + '" data-thumbnail-id="' + id + '">' +
            '<img class="product-single__thumbnail-img kent-gal-thumb' + (i ? '' : ' active') + '" src="' + u(300) + '" alt="' + esc(p.alt) + '" loading="lazy">' +
          '</a>' +
        '</div>'
      ));
    });
    return { slides: slides, thumbs: thumbs };
  }

  function swap(flkty, els) {
    var old = flkty.getCellElements();
    flkty.append(els);
    flkty.remove(old);
    flkty.select(0, false, true);
  }

  // Model line under the photo follows the selected slide (Flickity marks it .is-selected)
  function caption(container) {
    var el = container.querySelector('[data-kent-gal-model]');
    var cur = container.querySelector('[data-product-slideshow] .kent-gal-slide.is-selected') ||
      container.querySelector('[data-product-slideshow] .kent-gal-slide');
    if (!el || !cur) return;
    var t = cur.getAttribute('data-kg-model') || '';
    if (el.textContent !== t) el.textContent = t;
    el.hidden = !t;
  }

  function watch(container) {
    var slider = container.querySelector('[data-product-slideshow]');
    if (!slider || slider.kentWatched) return;
    slider.kentWatched = true;
    new MutationObserver(function () { caption(container); })
      .observe(slider, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    document.querySelectorAll('script[data-kent-gallery]').forEach(function (el) {
      var container = el.closest('[data-section-type]') || document;
      watch(container);
      caption(container);
    });
  }

  function show(container, colour) {
    var d = container && read(container);
    if (!d) return false;
    var list = d.map[colour];
    if (!list || !list.length) return false;

    var F = window.themeVendor && window.themeVendor.FlickityAsNavFor;
    var slider = container.querySelector('[data-product-slideshow]');
    var nav = container.querySelector('[data-product-single-media-thumbs]');
    var fl = F && slider && F.data(slider);
    if (!fl) return false;

    var b = build(d, list);
    watch(container);
    swap(fl, b.slides);
    caption(container);
    b.slides.forEach(function (s, i) { s.classList.toggle('media--hidden', i !== 0); });

    var fn = F && nav && F.data(nav);
    if (fn) {
      swap(fn, b.thumbs);
    } else if (nav) {
      nav.innerHTML = '';
      b.thumbs.forEach(function (t) { nav.appendChild(t); });
    }
    if (nav && !nav.hasAttribute('data-kent-gal-nav')) {
      nav.setAttribute('data-kent-gal-nav', '');
      // New thumbnail links have no theme click handler; keep them from opening the image.
      nav.addEventListener('click', function (e) {
        if (e.target.closest('[data-thumbnail-id]')) e.preventDefault();
      });
    }
    return true;
  }

  window.KentGallery = { show: show };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
